export default "__VITE_ASSET__DdCEC0Jz__"